import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import { ReactNode } from 'react';
import styles from './MenuAnnouncement.module.css';
import WinWithFriendsAnnouncement from './WinWithFriends';

const menuAnnouncementSettings = {
  winWithFriends: true,
};

const MenuAnnouncementWrapper = ({ children }: { children: ReactNode }) => (
  <div className={styles.wrapper}>
    <div className={styles.line} />
    {children}
  </div>
);

interface MenuAnnouncementProps {}

const MenuAnnouncement = observer(({}: MenuAnnouncementProps) => {
  const { activeSubscriptions } = useUserStore();

  if (
    activeSubscriptions.length > 0 &&
    menuAnnouncementSettings.winWithFriends
  ) {
    return (
      <MenuAnnouncementWrapper>
        <WinWithFriendsAnnouncement />
      </MenuAnnouncementWrapper>
    );
  }

  return null;
});

export default MenuAnnouncement;
